var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":_vm.theme.isDark}},[_c('div',{staticClass:"app-layout"},[_c('router-view')],1),_c('info-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }